<template>
  <el-dialog
    class="results-modal"
    :modal="false"
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="667px"
  >
    <el-table class="common-el-table-styles" border :data="list" :height="260" width="100%">
      <el-table-column prop="index" label="序号" width="60">
        <template slot-scope="{ $index }">{{ $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="bizName" label="账号名称" v-if="budgetType.isAccount" min-width="140" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="bizName" label="项目名称" v-if="budgetType.isProject" min-width="140" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="bizName" label="计划名称" v-if="budgetType.isAd" min-width="140" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="mediaName" label="媒体"></el-table-column>
      <el-table-column prop="oldBudget" label="原预算">
        <template slot-scope="{ row }">
          <span v-if="row.oldBudget === 0">不限</span>
          <span v-else>{{ row.oldBudget }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="targetBudget" label="修改后预算">
        <template slot-scope="{ row }">
          <span v-if="row.targetBudget === 0">不限</span>
          <span v-else>{{ row.targetBudget }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作结果" width="140" fixed="right">
        <template slot-scope="{ row }">
          <div class="btns">
            <span v-if="row.execStatus === 0">
              <em class="el-icon-warning"></em>
              待执行
            </span>

            <span v-if="row.execStatus === 1">
              <em class="el-icon-success"></em>
              执行中
            </span>

            <span style="color: green" v-if="row.execStatus === 2">
              <em class="el-icon-success"></em>
              修改成功
            </span>

            <span class="error" v-if="row.execStatus === 3">
              <span>
                <em class="el-icon-error"></em>
                <span :title="row.errorMsg">修改失败</span>

                <el-tooltip popper-class="result-error-msg-popover" effect="dark" :content="row.errorMsg">
                  <em v-if="row.errorMsg" style="margin-left: 5px" class="el-icon-warning-outline"></em>
                </el-tooltip>
              </span>
              <el-button type="text" @click="retryTask(row)" :loading="retryLoading">重试</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { retryModifyBudgetTask } from '@/api/convert.model'
export default {
  props: {
    value: Boolean,
    list: {
      type: Array
    }
  },
  data() {
    return {
      retryLoading: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    /**
     * @description: 根据当前返回的结果，获取修改预算的层级类型：账号、项目、广告
     */
    budgetType() {
      const [row] = this.list
      if (!row) return {}
      const bizType = row.bizType
      return {
        isAccount: bizType === 1,
        isProject: bizType === 2,
        isAd: bizType === 3
      }
    },
    dialogTitle() {
      const typeText = this.budgetType.isAccount ? '账号' : this.budgetType.isProject ? '项目' : '计划'
      return `批量修改${typeText}预算结果`
    }
  },
  methods: {
    retryTask(row) {
      this.retryLoading = true
      retryModifyBudgetTask({ taskId: row.id })
        .then((data) => {
          if (data.execStatus === 3) {
            this.$Message.warning(data.errorMsg)
          }
          if (data.execStatus === 2) {
            this.$Message.success('修改成功')
            const newList = this.list.map((i) => {
              if (i.bizName === row.bizName) {
                return data
              }
              return i
            })
            this.$emit('update:list', newList)
          }
        })
        .finally(() => {
          this.retryLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.results-modal {
  z-index: 4321 !important;
}
.btns {
  .error {
    color: red;
    display: flex;
    justify-content: space-between;
  }
}
</style>

<style>
.result-error-msg-popover {
  z-index: 4322 !important;
}
</style>
